import { render } from "./MemberPage.vue?vue&type=template&id=56af520a&scoped=true"
import script from "./MemberPage.vue?vue&type=script&lang=js"
export * from "./MemberPage.vue?vue&type=script&lang=js"

import "./MemberPage.vue?vue&type=style&index=0&id=56af520a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56af520a"]])

export default __exports__